// src/pages/Servicos.js
import React, { useState, useRef, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import './Servicos.css';
import ContactForm from '../components/ContactForm';
import heroImage from '../assets/servicos-hero.png'; // Verifique se é .png ou .jpg

// Lista de serviços completa e otimizada para SEO, agora com descrição estendida
const servicesData = {
  "Segurança Eletrônica": [
    {
      name: "Instalação de Câmeras de Segurança Intelbras",
      description: "Implementamos sistemas de CFTV com câmeras IP e analógicas de alta resolução, permitindo monitoramento remoto e gravação contínua para sua segurança.",
      extendedDescription: "Especialistas na instalação de câmeras Intelbras para ambientes residenciais e comerciais. Oferecemos desde modelos Wi-Fi para monitoramento rápido até sistemas IP e analógicos complexos com infraestrutura dedicada. Inclui configuração de acesso via smartphone, gravação em nuvem e detecção de movimento."
    },
    {
      name: "Sistema de CFTV IP e Analógico",
      description: "Projetamos e instalamos soluções de Circuito Fechado de TV, combinando o melhor da tecnologia IP e analógica para vigilância eficaz em qualquer ambiente.",
      extendedDescription: "Criamos projetos de CFTV personalizados, utilizando câmeras IP de alta definição para áreas críticas e câmeras analógicas para cobertura geral. Nossas soluções garantem integração total, fácil gerenciamento e escalabilidade para futuras expansões."
    },
    {
      name: "Manutenção de Sistemas de Vigilância",
      description: "Oferecemos manutenção preventiva e corretiva para garantir o pleno funcionamento do seu sistema de segurança, prolongando a vida útil dos equipamentos.",
      extendedDescription: "Manutenção completa para sistemas de CFTV, alarmes e cercas elétricas. Inclui verificação de cabeamento, limpeza de lentes, atualização de software, reparos de hardware e ajustes de configuração para garantir que seu sistema opere com máxima eficiência e confiabilidade."
    },
    {
      name: "Instalação de Alarmes Monitorados",
      description: "Proteja seu patrimônio com sistemas de alarme inteligentes que detectam invasões, fumaça ou vazamentos, enviando alertas em tempo real para seu celular e central de monitoramento.",
      extendedDescription: "Sistemas de alarme Intelbras com sensores de presença, abertura e fumaça. Ideal para residências e empresas, com a opção de monitoramento 24h por central de segurança ou auto-monitoramento via aplicativo, com disparo de sirene e notificações instantâneas."
    },
    {
      name: "Configuração de Gravadores (DVR/NVR)",
      description: "Configuramos seus gravadores digitais (DVR) e de rede (NVR) para acesso remoto seguro, armazenamento otimizado e reprodução de imagens com facilidade.",
      extendedDescription: "Serviço de configuração e otimização para DVRs e NVRs, incluindo acesso remoto via internet, ajuste de resolução e framerate, configuração de gravação por movimento e backup de imagens. Garantimos que você tenha controle total sobre suas gravações."
    },
    {
      name: "Instalação de Cerca Elétrica",
      description: "Aumente a segurança perimetral do seu imóvel com cercas elétricas homologadas, oferecendo uma barreira física e um alerta eficaz contra intrusões.",
      extendedDescription: "Instalação profissional de cercas elétricas de alta voltagem, com aterramento adequado e sinalização de segurança. Projetamos sistemas que se integram a alarmes, oferecendo proteção robusta para o perímetro de sua residência ou empresa."
    },
    // NOVOS da Intelbras:
    {
      name: "Instalação Kit Sistema de Alarme ANM 24 NET",
      description: "Instalação completa do sistema de alarme ANM 24 NET da Intelbras para proteção eficaz de ambientes residenciais e comerciais.",
      extendedDescription: "Implementação do Kit Sistema de Alarme ANM 24 NET, incluindo sensores, central de monitoramento e configuração de notificações. Ideal para quem busca uma solução robusta e conectada para segurança patrimonial."
    }
  ],
  "Redes e Conectividade": [
    {
      name: "Instalação e Configuração de Roteadores",
      description: "Otimizamos sua rede Wi-Fi com a instalação e configuração de roteadores de alto desempenho, garantindo velocidade e estabilidade para todos os seus dispositivos.",
      extendedDescription: "Configuração completa de roteadores para maximizar a cobertura e velocidade da sua internet. Inclui otimização de canais Wi-Fi, configuração de segurança, rede de convidados e QoS (Quality of Service) para priorizar seus dispositivos."
    },
    {
      name: "Implementação de Redes Wi-Fi Mesh",
      description: "Elimine zonas de sombra e lentidão. Criamos redes Wi-Fi Mesh que proporcionam cobertura total e um sinal robusto em grandes áreas residenciais ou comerciais.",
      extendedDescription: "Soluções Wi-Fi Mesh Intelbras para cobrir cada canto da sua propriedade com internet de alta velocidade. Ideal para casas grandes e escritórios, garantindo que você nunca perca o sinal ao se deslocar pelos ambientes."
    },
    {
      name: "Soluções de Wi-Fi Corporativo",
      description: "Desenvolvemos infraestruturas de rede sem fio robustas e seguras para empresas, com gestão centralizada e alta performance para múltiplas conexões.",
      extendedDescription: "Projetos de rede Wi-Fi empresarial com múltiplos Access Points gerenciáveis, garantindo conectividade estável e segura para funcionários e clientes. Soluções personalizadas para escritórios, hotéis e grandes ambientes corporativos."
    },
    {
      name: "Cabeamento Estruturado",
      description: "Projetamos e executamos sistemas de cabeamento estruturado (CAT5e, CAT6, Fibra Óptica) para dados, voz e vídeo, garantindo a espinha dorsal de sua comunicação.",
      extendedDescription: "Instalação de cabeamento estruturado com certificação, organização de racks e infraestrutura para redes de computadores, telefonia e CFTV. Fundamentais para a estabilidade e desempenho de qualquer rede profissional."
    },
    {
      name: "Configuração de Rede Local (LAN)",
      description: "Otimizamos a performance da sua rede local com configurações avançadas, garantindo que computadores, servidores e periféricos se comuniquem de forma eficiente e segura.",
      extendedDescription: "Serviços de configuração de switches, VLANs, roteamento e segurança para redes locais (LAN). Garantimos a comunicação eficiente entre seus dispositivos, otimizando o fluxo de dados e a performance do seu ambiente de TI."
    },
    // NOVOS da Intelbras:
    {
      name: "Instalação Kit Roteador Twibi",
      description: "Instalação de kits de roteadores Wi-Fi Mesh Twibi para cobertura de rede otimizada em ambientes amplos.",
      extendedDescription: "Montagem e configuração do kit de roteadores Twibi Intelbras, ideal para estender o sinal Wi-Fi e eliminar pontos cegos em residências ou pequenos escritórios, proporcionando conectividade fluida."
    },
    {
      name: "Instalação Roteador Twibi (Unidade)",
      description: "Instalação avulsa de roteadores Twibi para expansão ou criação de redes Mesh.",
      extendedDescription: "Serviço de instalação e configuração de uma unidade individual do roteador Twibi, seja para iniciar uma rede Mesh ou para expandir um sistema existente, garantindo a melhor performance e cobertura."
    },
    {
      name: "Instalação Roteadores Empresariais",
      description: "Instalação e configuração de roteadores projetados para ambientes corporativos, com foco em segurança e desempenho.",
      extendedDescription: "Implementação de roteadores Intelbras robustos para empresas, com configuração avançada de firewall, VPN, gerenciamento de banda e controle de acesso, otimizando a conectividade e segurança da rede corporativa."
    },
    {
      name: "Instalação de Antena de TV (AE 3010 ou AE 5010)",
      description: "Instalação profissional de antenas de TV Intelbras para recepção de sinal digital de alta qualidade.",
      extendedDescription: "Serviço de montagem e apontamento de antenas de TV modelos AE 3010 ou AE 5010, garantindo a melhor captação de sinal digital e uma imagem nítida para sua televisão."
    },
    {
      name: "Instalação de BANDA KU (SAT 800)",
      description: "Instalação de antenas para recepção de sinal de TV via satélite Banda Ku (SAT 800).",
      extendedDescription: "Montagem e alinhamento preciso de antenas para sinal de satélite Banda Ku SAT 800, proporcionando acesso a uma vasta gama de canais com estabilidade e qualidade de imagem."
    },
    {
      name: "Instalação de Antenas YAGI (AC 4417 ou AC 3117)",
      description: "Instalação de antenas YAGI para aplicações específicas de comunicação ou recepção de sinal.",
      extendedDescription: "Serviço de instalação e direcionamento de antenas YAGI modelos AC 4417 ou AC 3117, otimizadas para captação de sinal em condições desafiadoras ou para comunicação direcional."
    }
  ],
  "Automação Residencial e Comercial": [ // Categoria renomeada para incluir 'Comercial'
    {
      name: "Projetos de Casa Inteligente",
      description: "Transformamos sua casa em um ambiente inteligente e intuitivo, integrando sistemas para conforto, segurança e eficiência energética, sob medida para seu estilo de vida.",
      extendedDescription: "Consultoria e desenvolvimento de projetos de automação residencial completos. Integramos sistemas de iluminação, climatização, áudio/vídeo, segurança e acesso, criando uma experiência de moradia conectada e inteligente."
    },
    {
      name: "Integração com Amazon Alexa e Google",
      description: "Conectamos seus dispositivos inteligentes para que você controle sua casa por comandos de voz, elevando a praticidade e o luxo do seu lar.",
      extendedDescription: "Configure e integre seus dispositivos de automação com assistentes de voz como Amazon Alexa e Google Assistant. Controle a iluminação, temperatura, TV e outros aparelhos apenas com a sua voz."
    },
    {
      name: "Instalação de Iluminação Inteligente",
      description: "Crie ambientes personalizados com iluminação smart, ajustando cores, intensidade e programando cenários para cada momento do seu dia.",
      extendedDescription: "Instalação de lâmpadas, fitas de LED e interruptores inteligentes, permitindo controle via aplicativo ou assistente de voz. Crie cenas de iluminação para relaxar, trabalhar ou entreter seus convidados."
    },
    {
      name: "Automação de Cortinas e Persianas",
      description: "Automatize suas cortinas e persianas para controlar a luminosidade, privacidade e temperatura ambiente com um toque ou comando de voz.",
      extendedDescription: "Motores e módulos de automação para cortinas e persianas. Programe horários de abertura e fechamento, controle via aplicativo ou integre com outros sistemas de sua casa inteligente para maior conforto e economia de energia."
    },
    {
      name: "Sonorização de Ambientes",
      description: "Instalamos sistemas de áudio multiambiente para que você desfrute de suas músicas favoritas em qualquer cômodo da casa, com alta qualidade sonora e controle intuitivo.",
      extendedDescription: "Projetos de sonorização ambiente para residências e espaços comerciais. Instalação de caixas de som embutidas, amplificadores e sistemas de áudio sem fio, controláveis por aplicativo, criando a trilha sonora perfeita para cada momento."
    },
    // NOVOS da Intelbras + Automação Comercial
    {
      name: "Instalação de Facial para Controle de Acesso",
      description: "Implementação de sistemas de reconhecimento facial para controle de entrada e saída em comércios e salas de reunião, garantindo segurança e praticidade.",
      extendedDescription: "Instalação de leitores biométricos faciais em pontos estratégicos de seu comércio, como entradas e salas de reunião. Oferecemos soluções integradas para controle de acesso eficiente, registro de ponto e monitoramento de fluxo de pessoas, aumentando a segurança e otimizando a gestão."
    },
    {
      name: "Instalação de Interruptor Smart Intelbras",
      description: "Modernize a iluminação de seu comércio com interruptores inteligentes, controláveis via aplicativo ou assistente de voz.",
      extendedDescription: "Serviço de instalação de interruptores smart da Intelbras, permitindo o controle remoto da iluminação de seu estabelecimento, programação de cenários e automação para economia de energia e conforto."
    },
    {
      name: "Instalação de Kit Interruptores Smart Intelbras",
      description: "Instalação de kits de interruptores inteligentes Intelbras para automação de múltiplos pontos de luz em comércios.",
      extendedDescription: "Implementação de kits completos de interruptores smart Intelbras, ideal para automatizar a iluminação de grandes áreas comerciais ou escritórios, com controle centralizado e diversas opções de personalização."
    },
    {
      name: "Instalação da Luminária LSI 1600",
      description: "Instalação de luminárias inteligentes LSI 1600 para iluminação eficiente e automatizada em ambientes internos.",
      extendedDescription: "Serviço de montagem e configuração da luminária inteligente LSI 1600, oferecendo controle de intensidade, cor e programação de horários, ideal para criar ambientes personalizados em residências e comércios."
    },
    {
      name: "Instalação de Automatizador de Portão",
      description: "Instalação de motores e sistemas para automação de portões residenciais e comerciais, com segurança e comodidade.",
      extendedDescription: "Montagem e configuração de automatizadores de portão para diferentes tipos de portões (deslizante, basculante, pivotante). Inclui ajuste de percurso, teste de segurança e integração com controles remotos, videoporteiros ou sistemas de acesso."
    }
  ],
  "Controle de Acesso": [
    {
      name: "Instalação de Videoporteiro",
      description: "Mantenha a segurança de sua porta. Veja, converse e libere o acesso a visitantes de qualquer lugar, pelo seu smartphone ou unidade interna.",
      extendedDescription: "Instalamos videoporteiros Intelbras com câmeras de alta qualidade e integração com aplicativos para smartphone. Atenda a campainha e abra o portão de forma segura e conveniente, mesmo quando não estiver em casa."
    },
    {
      name: "Instalação de Fechadura Digital e Biométrica",
      description: "Modernize sua entrada. Instale fechaduras digitais com senha, biometria ou cartão, oferecendo controle e segurança sem a necessidade de chaves físicas.",
      extendedDescription: "Fechaduras digitais para portas de madeira ou vidro, com diferentes métodos de abertura (senha, biometria, cartão, aplicativo). Aumente a segurança e a praticidade, eliminando o uso de chaves e controlando o acesso de forma inteligente."
    },
    {
      name: "Sistemas para Condomínios",
      description: "Implementamos soluções robustas de controle de acesso para áreas comuns, portarias e garagens de condomínios, aumentando a segurança e a gestão de fluxo de pessoas e veículos.",
      extendedDescription: "Projetos completos de controle de acesso para condomínios, incluindo portarias remotas, controle de veículos (cancelas e tags), acesso biométrico para moradores e visitantes, e gestão de eventos através de softwares dedicados."
    },
    {
      name: "Controle de Acesso Corporativo",
      description: "Gerencie o acesso de funcionários e visitantes com sistemas modernos de biometria, cartões RFID ou senhas, garantindo a segurança e o controle de áreas restritas em empresas.",
      extendedDescription: "Soluções de controle de acesso para empresas, desde catracas biométricas e leitores de cartão até softwares de gestão de ponto e acesso a áreas restritas. Aumente a segurança, monitore o fluxo e otimize a gestão de pessoal."
    },
    // NOVOS da Intelbras:
    {
      name: "Instalação de Fechadura Digital de Sobrepor",
      description: "Instalação de fechaduras digitais de sobrepor para praticidade e segurança em portas de diversos tipos.",
      extendedDescription: "Serviço de instalação de fechaduras digitais de sobrepor, ideais para uma adaptação rápida e segura em portas existentes, oferecendo múltiplos métodos de acesso como senha e cartão."
    },
    {
      name: "Instalação Fechadura Digital de Embutir",
      description: "Instalação profissional de fechaduras digitais de embutir para um acabamento elegante e segurança robusta.",
      extendedDescription: "Montagem e configuração de fechaduras digitais de embutir, proporcionando um design clean e alta segurança. Perfeitas para portas novas ou que exigem um visual mais discreto e sofisticado."
    },
    {
      name: "Instalação de Fechadura Smart de Embutir e Hub/Central",
      description: "Instalação de fechaduras smart de embutir com integração de hub/central para controle total via app.",
      extendedDescription: "Serviço completo de instalação de fechadura smart de embutir e seu respectivo hub/central, permitindo o gerenciamento remoto de acessos, registro de entradas e saídas, e integração com outros dispositivos inteligentes."
    },
    {
      name: "Instalação de Fechadura Elétrica",
      description: "Instalação de fechaduras elétricas para portões e portas com acionamento remoto ou via interfone.",
      extendedDescription: "Montagem e conexão de fechaduras elétricas em portões sociais, portas de condomínios e residências. Integram-se facilmente com sistemas de interfonia e controle de acesso para liberação à distância."
    },
    {
      name: "Instalação de Porteiro",
      description: "Instalação de sistemas de porteiro eletrônico para comunicação e controle de acesso básico.",
      extendedDescription: "Serviço de instalação de porteiros eletrônicos, incluindo unidades externas e internas, garantindo a comunicação entre visitantes e residentes, e o controle de abertura de portões."
    },
    {
      name: "Instalação de Central de Interfonia Collective 8",
      description: "Instalação de central de interfonia para até 8 pontos em condomínios e edifícios comerciais.",
      extendedDescription: "Implementação da central de interfonia Collective 8 da Intelbras, ideal para edifícios e condomínios que necessitam de comunicação eficiente entre portaria e múltiplos apartamentos/salas, com alta qualidade de áudio."
    },
    {
      name: "Instalação de Fechadura Digital de Pressão",
      description: "Instalação de fechaduras digitais de pressão, prática e segura para portas de vidro ou madeira.",
      extendedDescription: "Serviço de montagem de fechaduras digitais de pressão, oferecendo uma solução robusta e sem necessidade de furos adicionais na porta, perfeita para portas de vidro ou em situações específicas."
    },
    {
      name: "Instalação de Fechadura Smart de Sobrepor e Hub/Central",
      description: "Instalação de fechaduras smart de sobrepor com hub/central para controle inteligente e remoto.",
      extendedDescription: "Montagem da fechadura smart de sobrepor e seu hub de comunicação, proporcionando controle de acesso via smartphone, registro de eventos e compatibilidade com automação residencial, ideal para quem busca praticidade e segurança."
    },
    {
      name: "Instalação de Módulo Interno / Externo de Videoporteiro",
      description: "Instalação avulsa de módulos internos ou externos para sistemas de videoporteiro.",
      extendedDescription: "Serviço de instalação de módulos internos (tela) ou externos (câmera/campainha) de videoporteiros, para reparo, substituição ou expansão de um sistema já existente."
    },
    {
      name: "Instalação Central de Interfonia Collective 4",
      description: "Instalação de central de interfonia para até 4 pontos, ideal para pequenos condomínios e escritórios.",
      extendedDescription: "Implementação da central de interfonia Collective 4 da Intelbras, perfeita para sistemas menores, garantindo comunicação clara e eficiente entre a portaria e até quatro unidades."
    },
    {
      name: "Instalação Central de Interfonia Collective 12",
      description: "Instalação de central de interfonia para até 12 pontos, oferecendo comunicação avançada para edifícios maiores.",
      extendedDescription: "Montagem e configuração da central de interfonia Collective 12 da Intelbras, ideal para edifícios de médio porte, proporcionando comunicação interna e com a portaria de forma eficaz e com recursos avançados."
    },
    {
      name: "Instalação Kit Central Modulare Mais",
      description: "Instalação de kits de centrais de interfonia Modulare Mais para sistemas de comunicação integrados.",
      extendedDescription: "Serviço completo de instalação do Kit Central Modulare Mais, uma solução versátil para comunicação interna em empresas e condomínios, permitindo expansão e integração com outros sistemas."
    }
  ],
  "Infraestrutura de TI e Energia": [ // Nova categoria para agrupar serviços de TI e energia
    {
      name: "Montagem e Manutenção de Servidores",
      description: "Oferecemos serviços completos de montagem, configuração e manutenção de servidores, garantindo a estabilidade e a segurança dos dados críticos de sua empresa.",
      extendedDescription: "Montagem personalizada de servidores (rack ou torre), instalação e configuração de sistemas operacionais, serviços de rede e backup. Suporte contínuo para manter seus servidores operando com máxima performance e segurança dos dados."
    },
    {
      name: "Montagem e Manutenção de Computadores",
      description: "Realizamos montagem, atualização e manutenção de computadores desktop e notebooks, otimizando o desempenho e resolvendo problemas de hardware e software.",
      extendedDescription: "Serviços de montagem de PCs personalizados para games ou trabalho, upgrade de componentes (RAM, SSD, placa de vídeo), diagnósticos e reparos de hardware e software, garantindo que seus equipamentos funcionem com agilidade."
    },
    {
      name: "Suporte Técnico em TI para Empresas",
      description: "Conte com suporte técnico especializado para sua infraestrutura de TI, resolvendo problemas, otimizando sistemas e garantindo a produtividade da sua equipe.",
      extendedDescription: "Atendimento técnico on-site e remoto para empresas, cobrindo desktops, notebooks, redes e servidores. Soluções rápidas e eficientes para problemas de hardware, software, conectividade e segurança, mantendo sua equipe produtiva."
    },
    // NOVOS da Intelbras:
    {
      name: "Instalação de Nobreak / UPS", // Incluindo nobreak aqui
      description: "Instalação de nobreaks e UPS para proteção de equipamentos eletrônicos e continuidade operacional em caso de quedas de energia.",
      extendedDescription: "Serviço de instalação e configuração de nobreaks (UPS) para garantir energia ininterrupta a servidores, computadores, sistemas de segurança e automação comercial. Proteja seus equipamentos contra picos de energia e quedas, assegurando a continuidade de suas operações."
    },
    {
      name: "Instalação de Inversor Solar OFF Grid",
      description: "Instalação de inversores solares para sistemas fotovoltaicos OFF Grid, garantindo energia autônoma.",
      extendedDescription: "Montagem e configuração de inversores solares OFF Grid, parte essencial de sistemas fotovoltaicos independentes da rede elétrica. Ideal para locais remotos ou para quem busca autonomia energética."
    },
    {
      name: "Instalação de Carregadores para Veículos Elétricos - Linha 7,4 kW",
      description: "Instalação de carregadores para veículos elétricos (monofásicos/bifásicos) de 7,4 kW para residências e comércios.",
      extendedDescription: "Serviço de instalação de estações de recarga para veículos elétricos da linha Intelbras de 7,4 kW, compatíveis com redes monofásicas e bifásicas. Solução prática e segura para recarregar seu veículo em casa ou no trabalho."
    },
    {
      name: "Instalação de Carregadores para Veículos Elétricos - Linha 11kW e 22kW",
      description: "Instalação de carregadores para veículos elétricos (trifásicos) de alta potência (11kW e 22kW) para comércios e condomínios.",
      extendedDescription: "Montagem e comissionamento de carregadores de alta potência (11kW e 22kW) para veículos elétricos, ideais para empresas, condomínios e pontos de recarga públicos que demandam agilidade e capacidade para vários veículos simultaneamente."
    }
  ]
};

const Servicos = () => {
  const [activeCategory, setActiveCategory] = useState(Object.keys(servicesData)[0]);
  const [selectedService, setSelectedService] = useState(null); // Para o modal/card grande de detalhe
  const [formMessage, setFormMessage] = useState(''); // Estado para a mensagem do formulário
  const formRef = useRef(null); // Ref para rolar até o formulário

  const scrollToForm = () => {
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleServiceSelect = (categoryName, service) => {
    setSelectedService(service);
    const message = `Quero solicitar um orçamento para ${service.name}. Descreva abaixo sua necessidade, o endereço de execução e demais detalhes específicos:`;
    setFormMessage(message);
    scrollToForm();
  };

  useEffect(() => {
    // Ao carregar a página, se não houver um serviço selecionado, o formulário pode ter uma mensagem genérica
    if (!selectedService && formMessage === '') {
        setFormMessage("Quero solicitar um orçamento para um ou mais serviços. Descreva abaixo sua necessidade e o endereço de execução:");
    }
  }, [selectedService, formMessage]);


  return (
    <div className="servicos-page-refactored">
      <Helmet>
        <title>Serviços Completos de Instalação e Suporte | Primo Trade Solutions</title>
        <meta name="description" content="Descubra a linha completa de serviços Primo Trade Solutions: instalação de câmeras de segurança, redes Wi-Fi Mesh, automação residencial inteligente, controle de acesso, infraestrutura de TI e soluções de energia. Peça seu orçamento especializado agora em São Paulo e região!" />
        <meta name="keywords" content="instalação de câmeras, segurança eletrônica, Wi-Fi Mesh, automação residencial, casa inteligente, automação comercial, controle de acesso, fechadura digital, videoporteiro, infraestrutura de TI, suporte técnico, nobreak, carregador veicular elétrico, serviços Intelbras, orçamento segurança, empresa de segurança eletrônica SP" />
      </Helmet>

      {/* --- Bloco 1: Banner Limpo (UX) --- */}
      <section className="servicos-hero-banner" style={{ backgroundImage: `url(${heroImage})` }}>
        {/* Apenas a imagem, sem texto sobreposto aqui */}
        {/* Adicione um alt text para SEO */}
        <img src={heroImage} alt="Especialistas em segurança eletrônica, redes e automação residencial e comercial em São Paulo e região" style={{ display: 'none' }} />
      </section>

      <div className="container main-content-area">
        {/* Título principal e descrição pós-banner, para melhor SEO e UX */}
        <div className="post-banner-intro">
            <h1>Sua Casa e Empresa em Perfeita Harmonia e Segurança</h1>
            <p>Descubra a gama completa de soluções tecnológicas da Primo Trade Solutions. Da segurança à automação, temos o serviço ideal para você. </p>
        </div>
        
        {/* --- Seção de Serviços com Menu Lateral (UX & SEO) --- */}
        <section className="servicos-area">
          <aside className="sidebar-menu">
            <h3>Nossas Especialidades</h3>
            <ul>
              {Object.keys(servicesData).map(category => (
                <li key={category}>
                  <button
                    className={activeCategory === category ? 'active' : ''}
                    onClick={() => {
                        setActiveCategory(category);
                        setSelectedService(null); // Limpa o serviço selecionado ao mudar de categoria
                    }}
                  >
                    {category}
                  </button>
                </li>
              ))}
            </ul>
          </aside>

          <div className="servicos-display">
            <h2>{activeCategory}</h2>
            {activeCategory === "Todos os Nossos Serviços de Instalação" ? (
                <p className="intro-description">Da consultoria inicial ao suporte pós-venda, cobrimos todas as suas necessidades em tecnologia e segurança. Explore nossas especialidades e descubra como podemos transformar seu ambiente.</p>
            ) : (
                <div className="services-items-grid">
                {servicesData[activeCategory].map(service => (
                    <div key={service.name} className={`service-card ${selectedService === service ? 'active-service' : ''}`}>
                    <h4>{service.name}</h4>
                    <p>{service.description}</p>
                    <button className="view-details-btn" onClick={() => setSelectedService(service)}>Ver Detalhes</button>
                    </div>
                ))}
                </div>
            )}

            {selectedService && (
                <div className="service-detail-modal"> {/* Usando modal/card grande */}
                    <div className="modal-content">
                        <h3>{selectedService.name}</h3>
                        <p className="extended-description">{selectedService.extendedDescription}</p>
                        <div className="modal-actions">
                            <button className="close-details-btn" onClick={() => setSelectedService(null)}>Fechar</button>
                            <button className="request-service-btn" onClick={() => handleServiceSelect(activeCategory, selectedService)}>
                                Solicitar Orçamento
                            </button>
                        </div>
                    </div>
                </div>
            )}
          </div>
        </section>

        {/* --- Bloco Processo e CTA (Marketing) --- */}
        <section className="servicos-processo">
            <h2>Nosso Processo é Simples e Transparente</h2>
            <div className="processo-steps">
                <div className="step-item"><span>1</span><h4>Contato Inicial</h4><p>Você seleciona o serviço e preenche o formulário.</p></div>
                <div className="step-item"><span>2</span><h4>Análise e Orçamento</h4><p>Nossa equipe técnica avalia sua necessidade e retorna com uma proposta.</p></div>
                <div className="step-item"><span>3</span><h4>Execução e Suporte</h4><p>Agendamos e realizamos o serviço com excelência, garantindo sua satisfação.</p></div>
            </div>
        </section>

        <section className="servicos-cta">
            <h2>Pronto para Transformar seu Projeto em Realidade?</h2>
            <p>Não perca tempo! Preencha o formulário abaixo e garanta um atendimento prioritário com um de nossos especialistas. Sua solução está a apenas um clique de distância.</p>
        </section>
      </div>

      {/* --- Bloco Final: Formulário de Contato (Conversão) --- */}
      <div ref={formRef}> {/* Referência para rolar */}
        <ContactForm initialMessage={formMessage} />
      </div>

    </div>
  );
};

export default Servicos;